import axios from "../../interceptors/axiosInterceptor";
import {
  CREATE_BASKET_PROMO_CITY_LEVEL_URL,
  CREATE_PROMO_CITY_LEVEL_URL,
  GET_LIST_OF_ACTIVE_PRODUCT_WITH_PROMO_CITY_LEVEL,
  GET_PROMOS_CITY_LEVEL_URL,
  GET_PROMO_CITY_LEVEL_BY_TYPE,
  GET_PROMO_CITY_LEVEL_DETAILS_URL,
  GET_PROMO_CITY_LEVEL_PRODUCT_URL,
  UPDATE_PROMO_CITY_LEVEL_STATUS_URL,
  GET_WAREHOUSE_URL,
  GET_ACTIVE_UCS_BY_CITY_ID,
  UPLOAD_CSV_USER_LEVEL_TYPE_PROMO,
  CREATE_BULK_PROMO_URL,
  UPDATE_PROMO_CITY_LEVEL_URL,
  DEACTIVATE_BULK_PROMO_URL,
} from "../../config/Url";
import {
  IGetQueryParams,
  IVolumetricPromoDetailResponseNormalized,
  IDynamicPromoDetailResponseNormalized,
  ICreatePromoPayload,
  ICreateBasketPromoPayload,
  IBasketPromoDetailResponseNormalized,
  IPromoBasketDetailResponse,
  IPromoDetailResponse,
  IDynamicPromoDetailResponse,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  normalizeBasketPromoDetailsResponse,
  normalizeDynamicPromoDetailsResponse,
  normalizeFetchPromoResponse,
  normalizePromoDetailsResponse,
} from "../../normalizer/PromoNormalizer";
import { PROMO_TYPE } from "../../config/constants";
import { normalizeFetchProductResponseForPromo } from "../../normalizer/GlobalProductNormalizer";
import { normalizeWarehouse } from "normalizer/ZonalConfigNormalizer";
import { IUpdatePromoPayload } from "interfaces/userLevelPromo.interface";
import { PromoType } from "components/pages/PromosCityLevel/constants/AddBulkPromosCityLevelConstats";

//Todo: call normalizeWarehouse in general function file instead of zonal

export const createPromoCityLevelApiCall = (
  cityId: string,
  payload: ICreatePromoPayload
) =>
  new Promise<IPromoDetailResponse>((resolve, reject) => {
    const url = CREATE_PROMO_CITY_LEVEL_URL.replace("{cityId}", cityId);
    axios
      .post(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createBasketPromoCityLevelApiCall = (
  cityId: string,
  payload: ICreateBasketPromoPayload
) =>
  new Promise<void>((resolve, reject) => {
    const url = CREATE_BASKET_PROMO_CITY_LEVEL_URL.replace("{cityId}", cityId);
    axios
      .post(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchPromosCityLevelApiCall = (
  cityId: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise((resolve, reject) => {
    const url = GET_PROMOS_CITY_LEVEL_URL.replace("{cityId}", cityId);
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 25
              ? true
              : false;
          resolve(
            normalizeFetchPromoResponse(data, pageNumber, isPaginatedRes)
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchPromoCityLevelDetailsApiCall = (id: string) =>
  new Promise<
    | IVolumetricPromoDetailResponseNormalized
    | IBasketPromoDetailResponseNormalized
    | IDynamicPromoDetailResponseNormalized
  >((resolve, reject) => {
    let url = GET_PROMO_CITY_LEVEL_DETAILS_URL.replace("{promoId}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          let normalizedRes:
            | IVolumetricPromoDetailResponseNormalized
            | IBasketPromoDetailResponseNormalized
            | IDynamicPromoDetailResponseNormalized;
          if (data.type === PROMO_TYPE.VOLUMETRIC) {
            normalizedRes = normalizePromoDetailsResponse(data);
          } else if (data.type === PROMO_TYPE.BASKET) {
            normalizedRes = normalizeBasketPromoDetailsResponse(data);
          } else {
            normalizedRes = normalizeDynamicPromoDetailsResponse(data);
          }
          resolve(normalizedRes);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updatePromoCityLevelStatusApiCall = (
  id: string
  // payload: IUpdatePromoStatusPayload
) =>
  new Promise<void>((resolve, reject) => {
    let url = UPDATE_PROMO_CITY_LEVEL_STATUS_URL.replace("{promoid}", id);
    axios
      .put(url, {}, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchActiveProductWithPromoCityLevelApiCall = (cityId: string) =>
  new Promise<string[]>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    const url = GET_LIST_OF_ACTIVE_PRODUCT_WITH_PROMO_CITY_LEVEL.replace(
      "{cityId}",
      cityId
    );
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data: string[] = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchPromoCityLevelByTypeApiCall = (
  cityId: string,
  type: string
) =>
  new Promise<
    | IPromoBasketDetailResponse[]
    | IPromoDetailResponse[]
    | IDynamicPromoDetailResponse[]
  >((resolve, reject) => {
    const url: string = GET_PROMO_CITY_LEVEL_BY_TYPE.replace(
      "{cityId}",
      cityId
    ).replace("{promoType}", type);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data:
            | IPromoBasketDetailResponse[]
            | IPromoDetailResponse[]
            | IDynamicPromoDetailResponse[] = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchProductsForPromoCityLevelApiCall = (
  cityId: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    const url = GET_PROMO_CITY_LEVEL_PRODUCT_URL.replace("{cityId}", cityId);
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 25
              ? true
              : false;
          resolve(
            normalizeFetchProductResponseForPromo(
              data,
              pageNumber,
              isPaginatedRes
            )
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchWarehouseByCityIdApiCall = (
  cityId?: string
  // queryParam?: IGetQueryParams
) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    if (cityId) {
      requestConfig.params = { cityId: cityId };
    }
    axios
      .get(GET_WAREHOUSE_URL, requestConfig)
      .then((response) => {
        const data = response && response.data;
        resolve(normalizeWarehouse(data));
      })
      .catch((error) => {
        const errorResponse = normalizeCatchErrors(error.response);
        reject(errorResponse);
      });
  });

export const fetchUCByCityIdApiCall = (
  cityId: string = "",
  queryParam: IGetQueryParams = {}
) =>
  new Promise((resolve, reject) => {
    let url = GET_ACTIVE_UCS_BY_CITY_ID.replace("{cityId}", cityId);
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(url, requestConfig)
      .then((response) => {
        const data = response && response.data;
        const normalizedData = normalizeWarehouse(data);
        resolve(normalizedData);
      })
      .catch((error) => {
        const errorResponse = normalizeCatchErrors(error.response);
        reject(errorResponse);
      });
  });

export const uploadUserLevelPromoCsvApiCall = (
  promoId: string,
  payload: FormData
  // queryParam: IGetQueryParams = {}
) =>
  new Promise<void>((resolve, reject) => {
    // let requestConfig: any = getAuthOptions(true);
    // requestConfig.params = queryParam;
    let url = UPLOAD_CSV_USER_LEVEL_TYPE_PROMO.replace("{promoId}", promoId);
    axios
      .post(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createUserLevelBulkPromoApiCall = (
  payload: FormData,
  promoType: PromoType
) =>
  new Promise<void>((resolve, reject) => {
    let url = CREATE_BULK_PROMO_URL.replace("{promoType}", promoType);
    axios
      .post(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const deactivateUserLevelBulkPromoApiCall = (payload: FormData) =>
  new Promise<void>((resolve, reject) => {
    let url = DEACTIVATE_BULK_PROMO_URL;
    axios
      .post(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updatePromoCityLevelApiCall = (
  id: string,
  payload: IUpdatePromoPayload
) =>
  new Promise<void>((resolve, reject) => {
    let url = UPDATE_PROMO_CITY_LEVEL_URL.replace("{promoid}", id);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
